import _ from 'underscore';
import { comparedDateRanges } from './compared-date-ranges';
import { primaryDateRanges } from './primary-date-ranges';
import { DateUtility, DateRangeOptions, ComparedDateRangesParams } from '../types';

export class DateRangesFactory {
  putil: DateUtility;

  constructor(putil: DateUtility) {
    this.putil = putil;
  }

  makePrimaryDateRangesAccessor(): (options: DateRangeOptions) => ReturnType<typeof primaryDateRanges> {
    return (options: DateRangeOptions) => {
      _.extend(options, { putil: this.putil });
      return primaryDateRanges(options as ComparedDateRangesParams);
    };
  }

  makeComparedDateRangesAccessor(): (options: DateRangeOptions) => ReturnType<typeof comparedDateRanges> {
    return (options: DateRangeOptions) => {
      _.extend(options, { putil: this.putil });
      return comparedDateRanges(options as ComparedDateRangesParams);
    };
  }
}
